const animateImages = () => {
	const sections = document.querySelectorAll(".section-main-blog");

	sections.forEach((item) => {
		if (item.querySelectorAll(".observe-me").length > 0) {
			function createObserver() {
				function handleIntersect(entries, observer) {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							let css_classlist = entry.target.classList;
							css_classlist.add("is-inview");

							observer.unobserve(entry.target);

							setTimeout(() => {
								css_classlist.remove("is-inview");
								css_classlist.remove("observe-me");
							}, 1000); // Duration matches the animation duration in SCSS
						}
					});
				}

				let options = {
					root: null,
					rootMargin: "0px",
					threshold: 0.0,
				};

				let observer = new IntersectionObserver(handleIntersect, options);
				let targets = item.querySelectorAll(".observe-me");
				targets.forEach((target, index) => {
					observer.observe(target);
				});
			}

			createObserver();
		}
	});
};

/* ---- Load-more progress persistence -----------------------------------
   Some in-app browsers (e.g. Instagram/Facebook's built-in browser opened
   from an ad click) don't reliably restore the page from the back-forward
   cache when the visitor hits "back" from a product page. Instead of
   restoring the exact DOM state, they do a full fresh reload of the
   collection page, which only shows page 1 - silently discarding
   everything the visitor had already loaded with "Load more".

   This saves the reached page number to sessionStorage on every
   successful load, and replays those loads automatically on page init
   so the visitor lands back where they left off instead of page 1. ---- */
const LOAD_MORE_STORAGE_PREFIX = "al_load_more_progress:";

function loadMoreStorageKey() {
	const params = new URLSearchParams(window.location.search);
	params.delete("page");
	const qs = params.toString();
	return LOAD_MORE_STORAGE_PREFIX + window.location.pathname + (qs ? "?" + qs : "");
}

function saveLoadMoreProgress(page) {
	try {
		sessionStorage.setItem(
			loadMoreStorageKey(),
			JSON.stringify({ page: page, savedAt: Date.now() })
		);
	} catch (e) {}
}

function readLoadMoreProgress() {
	try {
		const raw = sessionStorage.getItem(loadMoreStorageKey());
		if (!raw) return null;
		const data = JSON.parse(raw);
		// Ignore stale entries so we never restore very old sessions
		if (!data || !data.page || Date.now() - data.savedAt > 30 * 60 * 1000) {
			return null;
		}
		return data;
	} catch (e) {
		return null;
	}
}

function restoreLoadMoreProgress() {
	const progress = readLoadMoreProgress();
	const currentPageInput = document.querySelector("[data-current-page]");
	const totalPagesInput = document.querySelector("[data-total-pages]");
	const nextUrlInput = document.querySelector("[data-next-url]");
	if (!progress || !currentPageInput || !nextUrlInput) return;

	const totalPages = parseInt(totalPagesInput ? totalPagesInput.value : "1");
	const targetPage = Math.min(progress.page, totalPages);
	let page = parseInt(currentPageInput.value || "1");
	if (!targetPage || targetPage <= page) return;

	const button = document.querySelector(".js-load-more");
	if (button) {
		button.setAttribute("disabled", "");
		button.classList.add("loading");
	}

	function finish() {
		currentPageInput.value = page;
		if (button) {
			button.removeAttribute("disabled");
			button.classList.remove("loading");
			if (page >= totalPages) button.remove();
		}
		animateImages();
		if (typeof loadeMoreSlider_G === "function" && loadeMoreSlider_G != null) {
			loadeMoreSlider_G();
		}
	}

	function nextStep() {
		if (page >= targetPage) {
			finish();
			return;
		}
		page += 1;
		const url = nextUrlInput.value.replace(/page=[0-9]+/, "page=" + page);
		$.ajax({
			url: url,
			type: "GET",
			dataType: "html",
		})
			.done(function (responseHTML) {
				$(".load-more-grid").append(
					$(responseHTML).find(".load-more-grid").html()
				);
				colorSwatches();
				nextUrlInput.value = url.replace(/page=[0-9]+/, "page=" + (page + 1));
				currentPageInput.value = page;
				nextStep();
			})
			.fail(function () {
				// Stop trying to restore further pages if a request fails,
				// but leave whatever was already restored intact.
				finish();
			});
	}

	nextStep();
}

const loadItems = (button) => {
	const totalPages = parseInt($("[data-total-pages]").val());
	let currentPage = parseInt($("[data-current-page]").val());
	let currentPageScroll = currentPage + 1;

	currentPage = currentPage + 1;
	const nextUrl = $("[data-next-url]")
		.val()
		.replace(/page=[0-9]+/, "page=" + currentPage);
	const nextUrlScroll = $("[data-next-url]")
		.val()
		.replace(/page=[0-9]+/, "page=" + currentPageScroll);
	$("[data-current-page]").val(currentPage);

	button.setAttribute("disabled", "");
	button.classList.add("loading");

	$.ajax({
		url: nextUrl,
		type: "GET",
		dataType: "html",
		success: function (responseHTML) {
			$(".load-more-grid").append(
				$(responseHTML).find(".load-more-grid").html()
			);
			colorSwatches();
			saveLoadMoreProgress(currentPage);
		},
		complete: function () {
			if (currentPage <= totalPages) {
				const scollData = document.querySelector(".infinite-scroll__data");
				if (scollData && currentPage != totalPages) {
					scollData.querySelector("input[data-next-url]").dataset.nextUrl =
						nextUrlScroll;
					scollData.querySelector("input[data-next-url]").value = nextUrlScroll;
					scollData.querySelector(
						"input[data-current-page]"
					).dataset.currentPage = currentPage;
					scollData.querySelector("input[data-current-page]").value =
						currentPage;
					checkVisibility();
				}
				button.removeAttribute("disabled");
				button.classList.remove("loading");
				if (currentPage == totalPages) {
					button.remove();
				}

				animateImages();
				if (typeof loadeMoreSlider_G === 'function' && loadeMoreSlider_G != null) {
					loadeMoreSlider_G();
				}
			}
		},
	});
};

const checkVisibility = () => {
	const spinnerList = document.querySelectorAll(".js-infinite-scroll");
	spinnerList.forEach((spinner) => {
		const sectionObserver = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					loadItems(spinner);
					sectionObserver.unobserve(entry.target);
				}
			});
		});

		sectionObserver.observe(spinner);
	});
};

function loadMore() {
	document.querySelectorAll(".js-load-more").forEach((button) => {
		button.onclick = () => {
			loadItems(button);
		};
	});

	checkVisibility();
	animateImages();
	restoreLoadMoreProgress();
}

(function () {
	loadMore();
})();